import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { Protocol } from "@msuite/utils/types";
import { client } from "@/hono";
import { ProtocolsMenu } from "@/sites/protocols/protocols/protocols-menu";
import { columns } from "@/sites/protocols/protocols/table-config";

/** Props Interface */
interface ProjectProtocolsProps {
	projectId: string;
}

export function ProjectProtocols({ projectId }: ProjectProtocolsProps) {
	/** Hooks */

	/** Query */
	const {
		data: protocols,
		refetch,
		isLoading,
		queryKey,
	} = useQuery({
		queryKey: ["protocols", projectId],
		queryFn: async () => {
			const response = await client.protocols.index.$get({
				query: {
					projectId,
				},
			});
			const data = await responseHandler(response as any);
			return data.protocols as Protocol[];
		},
	});

	/** Render */
	return (
		<DataTable
			data={protocols as any}
			columns={columns}
			isLoading={isLoading}
			persistenceKey="protocols-table"
			refetch={refetch}
			queryKey={queryKey}
			menu={<ProtocolsMenu createQueryString={`?projectId=${projectId}`} />}
		/>
	);
}
